import React, {VoidFunctionComponent} from "react";

export const Target2SellBloc: VoidFunctionComponent<{ pID: string, espaceID: string }> = ({
                                                                                              pID,
                                                                                              espaceID
                                                                                          }) => {
    return (
        <div className="target2sell" id={`PPNA1QL127P68J-${pID}-${espaceID}`}/>
    );
};